import { render, staticRenderFns } from "./Tv.vue?vue&type=template&id=6ac9f1fc&"
import script from "./Tv.vue?vue&type=script&lang=js&"
export * from "./Tv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports